/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import EchocardiographyImage from "../../../../assets/final-images/servicepage/Cardiac-page/Artboard 4.jpg";
import NuclearImage from "../../../../assets/final-images/servicepage/Cardiac-page/Artboard 3.jpg";
import CalciumScoring from "../../../../assets/final-images/servicepage/Cardiac-page/Artboard 1.jpg";
import CTAImage from "../../../../assets/final-images/servicepage/Cardiac-page/Artboard 2.jpg";
import VascularImage from "../../../../assets/final-images/servicepage/Cardiac-page/Artboard 5.jpg";
import UnifiedCardiacImage from "../../../../assets/final-images/servicepage/Cardiac-page/Artboard 6.jpg";
import heartscan from "../../../../assets/final-images/servicepage/Cardiac-page/heartscan.png";
import shapeImage from "../../../../assets/final-images/shapes/6-01-01.png";
import { Link } from "react-router-dom";
import { useLenis } from "../../../SmoothScroll";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Faqs from "../../../Faqs";
import { Helmet } from "react-helmet-async";
export default function CardiacAndVascular() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  const faqs = [
  {
    question: "What is an echocardiogram and what does it show?",
    answer:
      "An echocardiogram is an ultrasound of the heart using high-frequency sound waves to produce real-time images of the heart's chambers, valves, walls, and blood flow. It can show how well the heart is pumping, detect valve abnormalities, identify pericardial effusion, evaluate structural defects, and diagnose heart failure, cardiomyopathy, and valvular disease."
  },
  {
    question: "What is the difference between a transthoracic and transesophageal echocardiogram?",
    answer:
      "A transthoracic echocardiogram (TTE) is the standard non-invasive echo performed with a probe on the chest. A transesophageal echocardiogram (TEE) involves passing a small probe down the esophagus to obtain closer, higher-resolution images - particularly useful when TTE images are limited or when greater detail is needed before cardiac surgery. Citrus Diagnostic Center offers transthoracic echocardiography."
  },
  {
    question: "Do I need to do anything special to prepare for an echocardiogram?",
    answer:
      "No special preparation is required for a standard transthoracic echocardiogram. You may eat, drink, and take medications as normal. Wear comfortable, loose-fitting clothing allowing easy access to your chest. The exam is painless and takes approximately 30 to 60 minutes."
  },
  {
    question: "What conditions can an echocardiogram detect?",
    answer:
      "An echocardiogram evaluates heart failure and reduced ejection fraction, mitral valve prolapse or stenosis, aortic valve disease, congenital heart defects, hypertrophic cardiomyopathy, pericardial effusion, left ventricular hypertrophy, and blood clots within the heart chambers. It is also used to monitor known cardiac conditions over time."
  },
  {
    question: "Who orders an echocardiogram and who interprets it?",
    answer:
      "Echocardiograms are most commonly ordered by cardiologists, internists, and primary care physicians when there is concern about heart function - after a new murmur is detected, following symptoms of shortness of breath or chest pain, or as part of pre-operative cardiac evaluation. At Citrus Diagnostic Center, the study is performed by a qualified cardiac sonographer and interpreted by our board-certified radiologist."
  }
];
  return (
    <>
    <Helmet>

       <title>Cardiac and Vascular Imaging | Citrus Diagnostic Center FL

</title>
        <meta
          name="description"
          content="What does cardiac imaging evaluate? Heart structure,blood flow and vascular health using evidence based methods that support accurate and consistent assessment.
"
        />
        <meta
          name="keywords"
          content="
vascular ultrasound
abdominal ultrasound
Vascular Imaging Center
Best Cardiac Imaging
cardiac ultrasound
nuclear cardiology
echocardiogram


"
        />
    </Helmet>
      <div>
        <div className=" font-robout">
          <div className="flex flex-col justify-center items-center px-5 xl:px-0  xl:py-36">
            <h1
              data-aos="fade-right"
              className="font-heading lg:text-[72px] text-[28px] leading-[1.2em] text-[#f5f5f5] font-normal text-center w-full 3xl:w-[50%]  capitalize"
            >
              Cardiac & Vascular Imaging at Citrus Diagnostic Center
            </h1>
            <p
              data-aos="fade-right"
              data-aos-delay="100"
              className=" text-[#cccccc] font-normal "
            >
              See disease earlier. Act with confidence.
            </p>
          </div>
          <div className="relative md:max-w-[90%] w-11/12 mx-auto xl:bg-[#0f0f0f] rounded-xl py-10 xl:py-44">
            <img
              src={shapeImage}
              alt="Citrus Diagnostic Center"
              className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-45
      
    "
            />
            <div
              className=" backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl
      shadow-lg w-full xl:w-[80%] mx-auto py-8 xl:py-16"
            >
              <div className="flex justify-center items-center text-center">
                {/* centered container */}
                <div className="w-full max-w-[900px] px-4 text-left mx-auto">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading capitalize pt-8 xl:pt-0 pb-8 text-center">
                    A Comprehensive Cardiovascular Imaging Program
                  </h2>
                  <p className="pb-2 ">
                    Cardiovascular disease is multifaceted-
                    <span className="font-extrabold">
                      {" "}
                      risk, anatomy, physiology, and structure
                    </span>{" "}
                    all matter.
                  </p>

                  <p className="pb-2 ">
                    Citrus Diagnostic Center offers a{" "}
                    <span className="font-extrabold">
                      unified cardiac and vascular imaging program
                    </span>{" "}
                    that integrates:
                  </p>

                  {/* centered list block but left-aligned content */}
                  <div className="flex justify-start">
                    <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 inline-block text-left">
                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                        <span>Preventive risk assessment</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                        <span>Advanced anatomic imaging</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                        <span>Physiologic evaluation</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                        <span>Real-time functional assessment</span>
                      </li>

                      <li className="flex items-start gap-2">
                        <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                        <span>Systemic vascular screening</span>
                      </li>
                    </ul>
                  </div>

                  <p className="py-2 ">
                    All studies are{" "}
                    <span className="font-extrabold">
                      radiologist-led, evidence-based
                    </span>
                    , and{" "}
                    <span className="font-extrabold">patient-centered.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="md:max-w-[90%] w-11/12 px-5 mx-auto  xl:py-10 py-6 xl:px-10 mb-5 xl:mb-20  bg-[#000000] rounded-xl">
          <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 lg:py-20">
            <div className="flex flex-col justify-center items-start  xl:px-0  ">
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                  Coronary Artery Calcium Scoring (CT)
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Simple. Fast. Insightful.
                </p>
              </div>
              <p className="pb-2">
                CT coronary calcium scoring is a non-contrast CT exam used to:
              </p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Detect calcified coronary plaque</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Refine cardiovascular risk beyond traditional factors
                  </span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Guide preventive therapy decisions</span>
                </li>
              </ul>
              <p className="pt-5 pb-2 text-[#cccccc] font-normal">
                Why it’s used:
              </p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Asymptomatic patients with risk factors</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Intermediate-risk individuals</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Objective baseline risk assessment</span>
                </li>
              </ul>
              <p className="pt-5 pb-2  text-[#cccccc] font-normal">
                Why patients choose it:
              </p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Quick exam</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>No IV contrast</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Low radiation dose</span>
                </li>
              </ul>
              <p className="py-2">
                Often the <span className="font-extrabold">first step</span> in
                preventive cardiac imaging.
              </p>
            </div>
            <div className="">
              <img
                src={CalciumScoring}
                alt="Calcium Scoring"
                className="w-auto h-auto rounded-3xl"
              />
            </div>
          </div>
          <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 lg:py-10">
            <div className="order-2 xl:order-1">
              <img src={CTAImage} alt="Coronary CT Angiography (CTA)" className="w-auto h-auto rounded-3xl" />
            </div>
            <div className="flex flex-col justify-center items-start  xl:pt-0 pt-10 xl:px-0 order-1 xl:order-2 ">
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize ">
                  Coronary CT Angiography (CTA)
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Advanced heart imaging-non-invasive and precise.
                </p>
              </div>
              <p className="pb-2">
                Coronary CTA evaluates the coronary arteries in detail to:
              </p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Identify atherosclerotic disease</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Assess plaque characteristics</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Evaluate chest pain and atypical symptoms</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Guide preventive and interventional care</span>
                </li>
              </ul>
              <h3 className="pt-5 pb-2 lg:text-[22px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal">
                AI-Assisted Plaque Analysis
              </h3>
              <p className="pb-2">AI supports coronary CTA by:</p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Assisting with plaque detection and characterization
                  </span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Improving visualization of coronary anatomy</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Enhancing consistency and reproducibility</span>
                </li>
              </ul>
              <p className=" py-2 xl:pb-0 ">
                CTA moves beyond “percent narrowing” toward
                <span className="font-extrabold">
                  {" "}
                  meaningful risk insight.
                </span>
              </p>
            </div>
          </div>
          <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 py-10">
            <div className="flex flex-col justify-center items-start px-5 xl:px-0">
              <div className="pb-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                  Cardiac Nuclear Medicine
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Physiology that informs management.
                </p>
              </div>
              <p className="pb-2">
                Cardiac nuclear imaging evaluates{" "}
                <span className="font-extrabold">
                  myocardial perfusion and physiologic significance
                </span>{" "}
                of coronary disease. It plays an important role when anatomy
                alone is not enough.
              </p>
              <p className="font-extrabold pb-2">Common applications</p>
              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Assessment of ischemia</span>
                </li>
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Functional significance of coronary disease</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Risk stratification in appropriate clinical settings
                  </span>
                </li>
              </ul>
              <p className="py-2">
                Studies are{" "}
                <span className="font-extrabold">
                  appropriately selected, physician-directed
                </span>
                , and{" "}
                <span className="font-extrabold">
                  interpreted in full clinical context
                </span>
                .
              </p>
            </div>
            <div>
              <img
                src={NuclearImage}
                alt="Cardiac Nuclear Medicine"
                className="w-auto h-auto rounded-3xl"
              />
            </div>
          </div>
        </div>
        <div
          style={{
            background:
              "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
          }}
        >
          <div className="md:max-w-[90%] w-11/12  xl:px-5 mx-auto py-24">
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 py-10">
              <div className="order-2 xl:order-1">
                <img
                  src={EchocardiographyImage}
                  alt="Echocardiography"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
              <div className="order-1 xl:order-2 flex flex-col justify-center items-start">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                    Echocardiography
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    Real-time insight into heart structure and function.
                  </p>
                </div>
                <p className="pb-2">
                  Echocardiography uses ultrasound to assess:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Cardiac chamber size and function</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Valve structure and performance</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Wall motion and hemodynamics</span>
                  </li>
                </ul>
                <p className="pt-5 pb-2 text-[#cccccc] font-normal">
                  Advantages:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>No radiation</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>No contrast</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Real-time physiologic assessment</span>
                  </li>
                </ul>
                <p className="py-2">
                  A cornerstone of both diagnosis and longitudinal cardiac care.
                </p>
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 lg:pt-20 md:py-10 py-7">
              <div className=" 2xl:px-12 xl:px-8  xl:py-10">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                    Vascular Ultrasound Imaging & Screening
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    Early insight. No radiation. Actionable information.
                  </p>
                </div>
                <p>
                  Vascular ultrasound evaluates blood vessels using sound waves-
                  <span className="font-extrabold">
                    safe, non-invasive, and radiation-free.
                  </span>
                </p>
                <p className="pb-2 pt-5 text-[#cccccc] font-normal">
                  Common applications:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Carotid artery evaluation for stroke risk</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Abdominal aortic aneurysm (AAA) screening</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Peripheral arterial disease assessment</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Venous insufficiency and thrombosis evaluation</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    Renal artery evaluation for suspected renovascular
                    hypertension
                  </li>
                </ul>
                <p className="pb-2 pt-5">
                  Particularly valuable for patients with:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Hypertension</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Diabetes</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Hyperlipidemia</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Smoking history</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Family history of vascular disease</span>
                  </li>
                </ul>
              </div>
              <div className="flex flex-col justify-center items-center">
                <img
                  src={VascularImage}
                  alt="Vascular Ultrasound Imaging & Screening"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
              <div className="flex flex-col justify-center items-center order-2 xl:order-1">
                <img
                  src={UnifiedCardiacImage}
                  alt="A Unified Cardiac Imaging Strategy"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
              <div className="2xl:px-12 xl:px-8  xl:py-10 flex flex-col justify-center items-start order-1 xl:order-2">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                    A Unified Cardiac Imaging Strategy
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    Right test. Right patient. Right time.
                  </p>
                </div>
                <p className="pb-2">
                  Cardiovascular imaging is most powerful when{" "}
                  <span className="font-extrabold">
                    risk, anatomy, physiology, and function
                  </span>{" "}
                  are evaluated together.
                </p>
                <p className="pb-2">
                  At Citrus Diagnostic Center, options include:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>CT calcium scoring for early risk assessment</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Coronary CTA with AI plaque analysis for anatomic disease
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Cardiac nuclear imaging for physiologic evaluation
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Echocardiography for structure and function</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Vascular ultrasound for systemic disease assessment
                    </span>
                  </li>
                </ul>
                <p className="py-2">
                  Imaging selection is guided by{" "}
                  <span className="font-extrabold">
                    clinical indication, risk profile
                  </span>
                  , and{" "}
                  <span className="font-extrabold">
                    evidence-based practice
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="md:max-w-[90%] w-11/12  xl:px-5 mx-auto pt-16">
            <div className="relative">
              {/* 🔥 Background Shape */}
              <img
                src={heartscan}
                alt="Cardia Scanning"
                className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-45
    "
              />
              <div
                className="grid lg:grid-cols-2  grid-cols-1 lg:gap-20 gap-5 backdrop-blur-[2px]
     bg-[linear-gradient(#ffffff0d_0%,#ffffff14_100%)]
      border border-[#ffffff49] rounded-xl
      shadow-lg xl:px-10  py-8 xl:py-16"
              >
                <div className=" p-5 xl:p-8 ">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                      For Referring Providers
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      Imaging that supports clinical decisions.
                    </p>
                  </div>
                  <p className="pb-2">Our program offers:</p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>ACR-aligned protocols</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>AI-enhanced coronary CTA</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Cardiac nuclear medicine capabilities</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Comprehensive vascular ultrasound services</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Clear, actionable reporting</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Direct radiologist collaboration</span>
                    </li>
                  </ul>
                  <p className="lg:w-4/5 py-2">
                    We partner with primary care providers, cardiologists,
                    nephrologists, and specialists to deliver imaging that{" "}
                    <span className="font-extrabold">
                      adds clarity-not complexity
                    </span>
                    .
                  </p>
                </div>
                <div className=" p-5 xl:p-8 ">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                      For Patients
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      Knowledge empowers prevention.
                    </p>
                  </div>
                  <p className="pb-2">Cardiac and vascular imaging can help:</p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Clarify risk</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Reduce uncertainty</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Support informed conversations with your physician
                      </span>
                    </li>
                  </ul>
                  <p className="py-2 pt-5">We prioritize:</p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Clear explanations</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Thoughtful exam selection</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Comfort and safety</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Respect for patient choice</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 backdrop-blur-[2px]
     bg-[linear-gradient(#ffffff0d_0%,#ffffff14_100%)]
      border border-[#ffffff49] rounded-xl
      shadow-lg xl:px-10  py-8 xl:pt-14 my-10"
              >
                <div className="p-5 xl:p-8 ">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  pb-8">
                    Why Choose Citrus Diagnostic Center
                  </h2>
                  <ul className="space-y-2 lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal font-heading">
                    <li className="flex items-start gap-3">
                      <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0 lg:text-[28px] text-[22px]" />
                      <span>Radiologist owned and operated</span>
                    </li>

                    <li className="flex items-start gap-3">
                      <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0 lg:text-[28px] text-[22px]" />
                      <span>
                        Preventive and advanced cardiac imaging under one roof
                      </span>
                    </li>

                    <li className="flex items-start gap-3">
                      <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0 lg:text-[28px] text-[22px]" />
                      <span>Coronary CTA with AI-assisted plaque analysis</span>
                    </li>

                    <li className="flex items-start gap-3">
                      <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0 lg:text-[28px] text-[22px]" />
                      <span>
                        CT calcium scoring and cardiac nuclear medicine
                      </span>
                    </li>

                    <li className="flex items-start gap-3">
                      <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0 lg:text-[28px] text-[22px]" />
                      <span>
                        Comprehensive vascular ultrasound (including renal
                        arteries)
                      </span>
                    </li>

                    <li className="flex items-start gap-3">
                      <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0 lg:text-[28px] text-[22px]" />
                      <span>
                        Academic-level standards with patient-first care
                      </span>
                    </li>
                  </ul>
                </div>
                <div className=" p-5 xl:p-8  ">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  pb-8">
                    Choosing Where Cardiac Imaging Is Performed
                  </h2>
                  <p className="pb-2">
                    Cardiac imaging often guides long-term care decisions.
                    Patients may wish to understand where imaging is performed
                    and whether studies are interpreted independently.
                  </p>
                  <p className="pb-2">
                    Independent, radiologist-led cardiac imaging supports
                    objective evaluation across multiple modalities, helping
                    ensure imaging decisions remain focused on diagnostic
                    clarity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[80%] w-[90%] mx-auto lg:pb-10 ">

          <Faqs faqs={faqs} />
        </div>

        <div className="md:max-w-[90%] w-11/12 mx-auto">
          <div className="flex justify-center items-center py-10">
            <div
              style={{
                background: `
              linear-gradient(90deg,
            #3d0e26 0%,
            #5a1f33 1%,
            #8b5e3c 40%,
            #8b5e3c 70%,
            #5a1f33 95%,
            #330a16 100%
          )
            `,
              }}
              className="flex justify-center items-center flex-col py-8 px-6 xl:px-8 rounded-xl xl:w-[668px] "
            >
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading texc  capitalize  pb-8">
                Schedule with Confidence
              </h2>
              <p className="pb-2 text-center">
                Advanced cardiac and vascular imaging-guided by precision,
                prevention, and physician oversight.
              </p>
              <div className="pt-10 pb-2">
                <Link
                  data-aos="fade-up"
                  to="/contact-us"
                  aria-label="Schedule Now"
                  className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
                >
                  Schedule Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
